/* LMC Orlando — Search Results (Chunk 13).

   Wires <lmc-search-tabs> — a wrapper around stacked result sections that
   keeps the tab nav in sync with whichever section is currently in view.

   Predictive autocomplete uses Dawn's <predictive-search> + <search-form>
   custom elements — no new JS needed there. */

(function () {
  'use strict';

  class LMCSearchTabs extends HTMLElement {
    constructor() {
      super();
      this.onTabClick = this.onTabClick.bind(this);
      this.onIntersect = this.onIntersect.bind(this);
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.lmc-search-tab'));
      this.sections = this.tabs
        .map((tab) => document.getElementById(tab.dataset.target))
        .filter(Boolean);

      if (this.tabs.length === 0 || this.sections.length === 0) return;

      this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick));

      // Observe each section; whichever has the largest intersection ratio wins.
      this.observer = new IntersectionObserver(this.onIntersect, {
        rootMargin: '-40% 0px -50% 0px',
        threshold: [0, 0.25, 0.5, 0.75, 1],
      });
      this.sections.forEach((section) => this.observer.observe(section));
    }

    disconnectedCallback() {
      this.tabs?.forEach((tab) => tab.removeEventListener('click', this.onTabClick));
      this.observer?.disconnect();
    }

    onTabClick(event) {
      event.preventDefault();
      const targetId = event.currentTarget.dataset.target;
      const target = document.getElementById(targetId);
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.setActive(targetId);
    }

    onIntersect(entries) {
      // Pick the section closest to the top of the viewport that's at least partially visible.
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible.length === 0) return;
      this.setActive(visible[0].target.id);
    }

    setActive(targetId) {
      this.tabs.forEach((tab) => {
        tab.classList.toggle('is-active', tab.dataset.target === targetId);
      });
    }
  }

  if (!customElements.get('lmc-search-tabs')) {
    customElements.define('lmc-search-tabs', LMCSearchTabs);
  }
})();
